module.exports = __webpack_public_path__ + "img/ex-shopping.d35b1316.jpg";